<div class="section launch">
    <div class="setup-heading">
        <ng-icon class="icon" [name]="'heroCog6ToothSolid'" [color]="'#822AC6'"></ng-icon>
        <span>Keep Exploring. Your agent has more to offer.</span>
    </div>
    <div *ngFor="let item of items" class="setup-content"
        [ngClass]="{'border-bottom': item.hasBorderBottom, 'website-texting': item.section === 'website-texting'}"
        [routerLink]="[item.route, { section: item.section }]">
        <div class="setup-item mb-0 d-flex align-items-start justify-content-center justify-content-md-between"
            [ngClass]="{}">
            <div class="d-flex align-items-center">
                <ng-icon class="icon" [name]="item.icon" [color]="'#822AC6'"></ng-icon>
                <div class="setup-labels-wrapper">
                    <span *ngIf="item.isNew" class="new-badge">NEW</span>
                    <div class="setup-item-label long d-flex align-items-center">
                        <span>{{ item.label }}</span>
                        <img *ngIf="item.isPremium" class="is-premium" src="assets/images/diamond-yellow.svg"
                            alt="Premium">
                    </div>
                    <div class="setup-item-label-info">{{ item.description }}</div>
                </div>
            </div>
            <img *ngIf="item.image" [src]="item.image" [alt]="item.label" class="explore-item-preview">
        </div>
    </div>
</div>